import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FiltrosOrdenAdmisionEntity, DataOrdenAdmisionEntity, PacienteOrdenAdmisionEntity } from '../../../../services/servicio-orden-admision.service';
import { EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';

@Component({
  selector: 'app-reporte-orden-admision',
  templateUrl: './reporte-orden-admision.component.html',
  styleUrls: ['./reporte-orden-admision.component.css']
})
export class ReporteOrdenAdmisionComponent implements OnInit {

  loading: boolean;
  mensajeError: string;
  fechaImpresion: Date;

  public filtros: FiltrosOrdenAdmisionEntity = {};

  entidad: EntidadEmpresarialEntity;

  verValores: boolean;
  head: PacienteOrdenAdmisionEntity;
  data: DataOrdenAdmisionEntity[] = [];

  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe(params => {
      this.filtros.codigoBaseDatos = params['codigoBaseDatos'];
      this.filtros.uncoSede = Number(params['uncoSede']);
      this.filtros.consecutivo = params['consecutivo'];
    });
  }

  ngOnInit() {
  }

  // Listener

  updateLoading(value: boolean) {
    this.loading = value;
    this.mensajeError = null;
  }

  updateError(error: string) {
    this.loading = false;
    this.mensajeError = error;
  }

  updateData( response: { entidad: EntidadEmpresarialEntity, data: DataOrdenAdmisionEntity[], valores: boolean}) {
    this.mensajeError = null;
    this.loading = false;
    this.fechaImpresion = new Date();

    this.entidad = response.entidad;
    this.head = this.getHeadData(response.data);
    this.data = response.data;
    this.verValores = response.valores;
  }

  // Auxiliares

  isPrepare() {
    return !this.loading && !this.mensajeError;
  }

  isPrepareData() {
    return this.isPrepare() && this.data && this.data.length > 0;
  }

  getHeadData(data: DataOrdenAdmisionEntity[]): PacienteOrdenAdmisionEntity {
    let paciente: PacienteOrdenAdmisionEntity;
    if (data && data.length > 0) {
      const d = data[0];
      paciente = {
        afiliado : d.afiliado,
        empresa : d.empresa,
        consecutivoAdmision : d.consecutivoAdmision,
        edad : d.edad,
        fechaAdmision : d.fechaAdmision,
        fechaNacimiento : d.fechaNacimiento,
        fechaSalidaAdmision : d.fechaSalidaAdmision,
        numeroIdentificacion : d.numeroIdentificacion,
        puntoAtencion : d.puntoAtencion,
        rangoSalarial : d.rangoSalarial,
        sede : d.sede,
        tipoAfiliado : d.tipoAfiliado,
        tipoDocumento : d.tipoDocumento
      };
    }

    return paciente;
  }

  getTotal(): number {
    let value = 0;

    if (this.data && this.data.length > 0) {
      this.data.forEach((d: DataOrdenAdmisionEntity) => {
        value += (d.cantidad) * (d.valorUnitario);
      });
    }

    return value;
  }
}
